import { DomainName } from "@/lib/constants/domains";
import {
  GeneratorStateFields,
  useGeneratorStateFields,
} from "./generatorStore";
import { SocialStateFieldsExport, useSocialStateFields } from "./socialStore";
import { WebPageState, useWebStateFields } from "./webPageStore";

const useStoreFields = (): Record<
  DomainName,
  GeneratorStateFields | SocialStateFieldsExport | WebPageState
> => {
  const generator = useGeneratorStateFields();
  const social = useSocialStateFields();
  const web = useWebStateFields();

  return { social, generator, web };
};

export default useStoreFields;
